
export { langTitleDict } from "/vercel/path0/libs/constants/src/lib/intl.ts"
export { localesList } from "/vercel/path0/libs/constants/src/lib/intl.ts"